import { defineStore } from 'pinia';
import { useApi } from '../composables/useApi';
import { useProfileStore } from './profileStore';
import { useNotifications } from '../composables/useNotifications';

export const useFeatureStore = defineStore('features', {
  state: () => ({
    features: [],
    isLoading: false,
    error: null,
    isLoaded: false
  }),
  getters: {
    getFeatureStatus: (state) => (routeName) => {
      const feature = state.features.find(f => f.route_name === routeName);
      return feature ? feature.isEnabled : true; 
    },
    canAccessFeature: (state) => (routeName) => {
      const profileStore = useProfileStore();
      // 1. Admin always has access
      if (profileStore.professionalProfile?.role === 'admin') return true;

      // 2. Check the feature flag
      const feature = state.features.find(f => f.route_name === routeName);
      // If feature is registered and disabled, return false. Otherwise true.
      if (feature && feature.isEnabled === false) return false;
      return true;
    }
  },
  actions: {
    async fetchFeatures() {
      this.isLoading = true;
      const { get } = useApi();
      try {
        const response = await get('/admin/features');
        console.log('[FeatureStore] Features loaded:', response);
        this.features = Array.isArray(response) ? response : [];
        this.isLoaded = true;
      } catch (error) {
        console.error('Failed to load feature flags:', error);
      } finally {
        this.isLoading = false;
      }
    },
    async createFeature(featureData) {
      const { post } = useApi();
      const { notifySuccess, notifyError } = useNotifications();
      try {
        await post('/admin/features', featureData);
        notifySuccess(`تمت إضافة الميزة: ${featureData.label}`);
        await this.forceRefresh();
        return true;
      } catch (e) {
        notifyError('فشل إضافة الميزة');
        return false;
      }
    },
    async updateFeatureStatus(id, isEnabled) {
      const { put } = useApi();
      const { notifySuccess, notifyError } = useNotifications();
      
      // Optimistic Update
      const oldFeatures = [...this.features];
      const idx = this.features.findIndex(f => f.id === id);
      if (idx !== -1) this.features[idx].isEnabled = isEnabled;

      try {
        await put('/admin/features', { id, isEnabled });
        notifySuccess(isEnabled ? 'تم تفعيل الميزة' : 'تم تعطيل الميزة');
      } catch (e) {
        this.features = oldFeatures; // Revert
        notifyError('فشل تحديث الحالة في السيرفر');
      }
    },
    async deleteFeature(id) {
        const { delete: apiDelete } = useApi();
        try {
            await apiDelete(`/admin/features?featureId=${id}`);
            this.features = this.features.filter(f => f.id !== id);
        } catch (e) { console.error(e); }
    },
    async forceRefresh() {
        this.isLoaded = false;
        await this.fetchFeatures();
    }
  }
});
